module.exports = __webpack_public_path__ + "img/float-activity-410.b21841d6.png";